import { sharedCriteriaFields, sharedFeesFields } from './shared';

export const merchantCashAdvanceCriteria = [
  ...sharedCriteriaFields(),
  {
    columns: 6,
    field: 'transactionsPerMonthAvg',
    fields: [
      {
        field: 'greaterThan',
        label: 'Minimum',
        type: 'currency',
      },
      {
        field: 'lowerThan',
        label: 'Maximum',
        type: 'currency',
      },
    ],
    label: 'Monthly card sales',
  },
  {
    columns: 6,
    fields: [
      {
        field: 'monthsRemainingOnBusinessLease',
        columns: 12,
        rightElement: '60 MONTHS',
        label: '0 MONTHS',
        max: 60,
        min: 0,
        type: 'slider',
      },
    ],
    label: 'Minimum time left on business lease',
  },
  {
    fields: [
      {
        optionsColumns: 6,
        field: 'guarantees',
        type: 'multiple',
      },
    ],
    label: 'Required guarantees',
  },
  {
    fields: [
      {
        columns: 12,
        field: 'homeowner',
        type: 'boolean',
      },
    ],
    label: 'Do you require home ownership for personal guarantees?',
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'useOfFunds',
        optionsColumns: 4,
        type: 'multiple',
      },
    ],
    label: 'For what funding purposes is this product suitable?',
  },
];
export const merchantCashAdvanceFees = sharedFeesFields(false);
